import { IconButton } from "@App/Components/common/IconButton/IconButton";
import { SeasonalTireChangeIcon, TireSparkleIcon } from "@App/Components/common/Icons";
import { Organization, Service } from "@App/types";
import { Services } from "@App/types/enums";
import { OrganizationShouldDisplayAsNonBookableForTires } from "@App/utils/conditionals/combinations";
import {
  OrganizationIsAthlon,
  OrganizationIsMobilityConcept,
} from "@App/utils/conditionals/organization";
import { Fragment, FunctionComponent } from "react";

type TireServiceStepProps = {
  services: Service[];
  selectService: any;
  organization: Organization;
  secondary: boolean;
};

export const TireServiceStep: FunctionComponent<TireServiceStepProps> = (
  props: TireServiceStepProps,
) => {
  return (
    <Fragment>
      <div className="overflow-hidden">
        <div
          className={`md:w-fit ease-in-out grid grid-cols-1 xs:grid-cols-2 gap-2 mb-4 mt-4 w-full`}
        >
          {!OrganizationIsMobilityConcept(props.organization) && (
            <IconButton
              title={"Reifenersatz"}
              onClick={() =>
                props.selectService(
                  OrganizationShouldDisplayAsNonBookableForTires(props.organization),
                  props.services.find((service) => service.id === Services.WHEELCHANGE),
                  false,
                  "Reifenersatz",
                  props.secondary,
                )
              }
              icon={<TireSparkleIcon primary className={"w-10 h-10"} />}
            />
          )}
          {OrganizationIsMobilityConcept(props.organization) && (
            <IconButton
              title={"Reifenersatz"}
              onClick={() =>
                props.selectService(
                  false,
                  props.services.find((service) => service.id === Services.WHEELREPLACEMENT),
                  false,
                  "Reifenersatz",
                  props.secondary,
                )
              }
              icon={<TireSparkleIcon primary className={"w-10 h-10"} />}
            />
          )}
          <IconButton
            title={"Saisonaler Räderwechsel"}
            onClick={() =>
              props.selectService(
                false,
                props.services.find((service) => service.id === Services.WHEELCHANGE),
                true,
                "Saisonaler Räderwechsel",
                props.secondary,
              )
            }
            icon={<SeasonalTireChangeIcon primary className={"w-10 h-10"} />}
          />
          {OrganizationIsAthlon(props.organization) && (
            <IconButton
              title={"Rädereinlagerung"}
              onClick={() =>
                props.selectService(
                  false,
                  props.services.find((service) => service.id === Services.TIRESTORAGE),
                  false,
                  "Rädereinlagerung",
                  props.secondary,
                )
              }
              icon={<TireSparkleIcon primary className={"w-10 h-10"} />}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};
